/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
    profile: {
        maxWidth: '880px',
        borderTop: '1px solid #888787',

        '& > div': {
            display: 'flex',
            marginTop: '0.9rem',
            paddingBottom: '0.8rem',
            borderBottom: '1px solid #888787',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },

            '& > span': {
                color: '#000',
                width: '150px',
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
                display: 'inline-block',
                '&:first-child': {
                    width: '25%',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                },
                '&:last-child': {
                    width: '50%',
                },
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },
            },
        },
    },
});

const DesktopProfileAndPasswordPlants = ({ userProfile, classes }) => (
    <div className={classes.profile}>
        <div>
            <span>First name</span>
            <span>{userProfile.firstName}</span>
        </div>

        <div>
            <span>Last name</span>
            <span>{userProfile.lastName}</span>
        </div>

        <div>
            <span>Email address</span>
            <span>{userProfile.email}</span>
        </div>
    </div>
);

DesktopProfileAndPasswordPlants.propTypes = {
    classes: object.isRequired,
    userProfile: object.isRequired,
};

export default withStyles(styles)(DesktopProfileAndPasswordPlants);
